import { isGovernedTarget, useGovernedNavigate } from "@/lib/navigation";

// RC50 V5-D NAV-007/008: a Copilot navigation affordance is rendered ONLY when its server-built
// target is a governed in-app destination, and clicking it always transitions (no "#", no no-op).
export function GovernedLink({ target, className, children, testId = "copilot-card-action" }) {
  const go = useGovernedNavigate();
  if (!isGovernedTarget(target)) return null;
  return (
    <a href={target} className={className} data-testid={testId} data-target={target}
      onClick={(e) => { if (e.metaKey || e.ctrlKey) return; e.preventDefault(); go(target); }}>
      {children}
    </a>
  );
}
